import React, { useState, useEffect } from 'react';
import LandingNavbar from './LandingNavbar';
import LandingHero from './LandingHero';
import PublicClassesSection from './PublicClassesSection';
import LandingAbout from './LandingAbout';
import LandingFooter from './LandingFooter';
import LoginModal from './LoginModal';

const LandingPage = ({ onLogin, apiBaseUrl }) => {
  const [publicClasses, setPublicClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showLoginModal, setShowLoginModal] = useState(false);

  // Fetch public classes
  useEffect(() => {
    const fetchPublicClasses = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${apiBaseUrl}/public/classes`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (response.ok) {
          const data = await response.json();
          setPublicClasses(data.classes || []);
        } else {
          throw new Error('Failed to fetch public classes');
        }
      } catch (err) {
        setError(err.message);
        setPublicClasses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPublicClasses();
  }, [apiBaseUrl]);

  const handleLoginClick = () => {
    setShowLoginModal(true);
  };

  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
  };

  const handleLogin = async (credentials) => {
    try {
      await onLogin(credentials);
      setShowLoginModal(false);
    } catch (error) {
      throw error;
    }
  };

  const scrollToAbout = () => {
    setTimeout(() => {
      const aboutSection = document.getElementById('about-section');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <LandingNavbar 
        onLoginClick={handleLoginClick}
        onAboutClick={scrollToAbout}
      />

      <main className="flex-1">
        <LandingHero />

        {/* Public Classes Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Public Courses</h2>
            <p className="text-gray-600">Explore available courses open to the public</p>
          </div>
          <PublicClassesSection 
            classes={publicClasses}
            loading={loading}
            error={error}
          />
        </div>

        {/* About Section */}
        <div id="about-section" className="bg-white border-t">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <LandingAbout />
          </div>
        </div>
      </main>

      <LandingFooter />

      <LoginModal
        isOpen={showLoginModal}
        onClose={handleCloseLoginModal}
        onLogin={handleLogin}
      />
    </div>
  );
};

export default LandingPage;

